import SupplementalDocuments from './SupplementalDocuments';
export { SupplementalDocuments };
export default SupplementalDocuments;
